import React from 'react';
import { format } from 'date-fns';
import WeatherSection from './components/WeatherSection';
import './WeatherTab.css';

interface WeatherData {
  windSpeed?: number;
  windSpeedUnit?: string;
  windDirection?: string;
  skyCondition?: string;
  temperature?: number;
  temperatureUnit?: string;
  soilMoisture?: string;
  humidity?: number;
}

interface WeatherTabProps {
  weatherInfo: {
    weather: {
      start?: WeatherData;
      end?: WeatherData;
    };
    startDate?: string;
    endDate?: string;
  };
}

const WeatherTab = ({ weatherInfo }: WeatherTabProps) => {
  const { weather, startDate, endDate } = weatherInfo;

  const formatDateTime = (dateString?: string): string => {
    if (!dateString) return '';
    return format(new Date(dateString), 'MMM d, yyyy hh:mma').toUpperCase();
  };

  return (
    <div
      data-testid="weather-tab"
      className="weather-tab-container"
      style={{
        height: 'calc(100vh - 373px)',
        overflowY: 'auto',
        clipPath: 'inset(0 round 8px)'
      }}
    >
      <div className="px-6 py-8" style={{ paddingBottom: '72px' }}>
        <div className="flex weather-sections">
          <WeatherSection
            title="START WEATHER"
            dateTime={formatDateTime(startDate)}
            weatherData={weather?.start}
          />

          <WeatherSection
            title="END WEATHER"
            dateTime={formatDateTime(endDate)}
            weatherData={weather?.end}
          />
        </div>
      </div>
    </div>
  );
};

export default WeatherTab;
